import Image from 'next/image';
import { Typography } from '@/components/common';

interface Props {
	message: string;
}

export const EmptyBoxScreen: React.FC<Props> = ({ message }) => {
	return (
		<div className="h-[80%] flex flex-col justify-center items-center p-1">
			<Image
				src={'/img/common/empty-box.png'}
				width={188}
				height={150}
				alt=""
				quality={75}
			/>
			<Typography
				type="regular-18"
				className="font-normal text-center px-8 md:px-0"
			>
				{message}
			</Typography>
		</div>
	);
};
